import { Loader2 } from 'lucide-react'
import { btnPrimaryClass, btnSecondaryClass } from './classes'

const VARIANTS = {
  primary: btnPrimaryClass,
  cta: btnPrimaryClass,
  secondary: btnSecondaryClass,
  ghost:
    'bg-transparent text-[var(--muted-foreground)] hover:bg-[var(--accent)] hover:text-[var(--foreground)] focus-visible:ring-[var(--ring)]',
  danger:
    'bg-[var(--destructive)] text-[var(--destructive-foreground)] shadow-[var(--shadow-xs)] hover:opacity-92 focus-visible:ring-[var(--destructive)]',
  dangerGhost:
    'bg-transparent text-[var(--destructive)] hover:bg-[color-mix(in_oklab,var(--destructive)_10%,transparent)] focus-visible:ring-[var(--destructive)]',
}

const SIZES = {
  sm: 'h-9 min-h-9 px-3 text-[0.8125rem] gap-1.5',
  md: 'h-10 min-h-10 px-5 text-sm gap-2',
  lg: 'h-12 min-h-12 px-7 text-base gap-2',
}

const Button = ({
  variant = 'primary',
  size = 'md',
  icon,
  loading = false,
  disabled = false,
  type = 'button',
  className = '',
  children,
  ...rest
}) => (
  <button
    type={type}
    disabled={disabled || loading}
    className={`inline-flex shrink-0 items-center justify-center rounded-[var(--radius-md)] font-medium transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60 ${VARIANTS[variant] || VARIANTS.primary} ${SIZES[size] || SIZES.md} ${className}`}
    {...rest}
  >
    {loading ? (
      <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
    ) : (
      icon && <span className="inline-flex shrink-0 items-center">{icon}</span>
    )}
    {children}
  </button>
)

export default Button
